export default {
  horizontal: {
    margin: '0',
    padding: '0',
  },
  vertical: {
    margin: '0',
    padding: '0',
  },
};
